import { useCallback } from "react";

import type { PaymentCreditInput } from "@/lib/gql/__generated__/graphql";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import { HOTEL_APPLICATION_DATA_QUERY } from "@/components/features/_shared/repository/hotel-application-data/query/schema";
import { START_GUIDE_QUERY } from "@/components/features/_shared/repository/start-guide/query/schema";

import { PAYMENT_CREDIT_MUTATION } from "./mutation";
import * as Query from "../../query";

export const usePaymentCreditMutation = () => {
	const { mutationFunc } = useCustomMutation(PAYMENT_CREDIT_MUTATION);
	const onUpdatePaymentCredit = useCallback(
		async (input: PaymentCreditInput) => {
			return await mutationFunc({
				variables: { input },
				refetchQueries: [
					{
						query: Query.Schema.PAYMENT_CREDIT_QUERY,
						variables: {
							hotelID: input.hotelID,
						},
					},
					{
						query: HOTEL_APPLICATION_DATA_QUERY,
						variables: {
							hotelID: input.hotelID,
						},
					},
					{
						query: START_GUIDE_QUERY,
						variables: {
							hotelID: input.hotelID,
						},
					},
				],
			});
		},
		[mutationFunc],
	);

	return {
		onUpdatePaymentCredit,
	};
};
